import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { PartsDataRequestPayloadTypes } from '../models/parts-management';

const PartManagement = {
  fetchPartData: async () => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.THINGS_PARTS_BASE_URL);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  getMachine: async (payload: PartsDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.THINGS_PARTS_BASE_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addPart: async (payload: object) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.THINGS_PARTS_BASE_URL, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updatePart: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(`${apiPath.THINGS_PARTS_BASE_URL}/${payload.part_id}`, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  deletePart: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.delete(`${apiPath.THINGS_PARTS_BASE_URL}/${payload.part_id}`);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  bulkUpload: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(
        `${apiPath.THINGS_PARTS_BASE_URL}bulk/${payload.machine_id}`,
        payload.data
      );
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default PartManagement;
